import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { DropdownMenuAnchor } from '../../patched-dropdown/Dropdown.mjs';

const DropdownAnchor = forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ jsx(
      DropdownMenuAnchor,
      {
        "data-scope": "dropdown",
        "data-part": "anchor",
        ref: forwardedRef,
        ...props
      }
    );
  }
);

export { DropdownAnchor };
//# sourceMappingURL=Anchor.mjs.map
